<script>
import ActionTemplates from './ActionTemplates'
import ActionSelectionInput from './ActionSelectionInput'
import InputSelection from './InputSelection'
import ActionForm from './ActionForm'
import UUID from 'uuid/v4'


export default {

  components: {
    ActionSelectionInput,
    InputSelection,
    ActionForm
  },

  props: {
    existingAction: {
      type: Object
    },

    value: {
      type: Array
    },

    workflow: {
      type: Object
    }
  },

  data() {
    return {
      internalValue: this.value,
      selectedActionTemplates: [],
      selectedActionUuid: null,
      action: null,

      searchQuery: "",

      customStyle: {}
    }
  },

  methods: {
    addAction() {
      this.internalValue.push(this.action)
      this.$emit('input', this.internalValue)
      this.$emit('close')
    }
  },

  computed: {
    actionTemplates() {
      return ActionTemplates.storage.allGrouped()
    },

    actionTemplateCollection() {
      let collection = ActionTemplates.storage.all()
      if (!this.searchQuery) { return collection }
      let query = this.searchQuery.toLowerCase()
      return collection.filter((template)=>{
        return template.searchContent.indexOf(query) >= 0
      })
    },

    selectedActionTemplate() {
      return this.actionTemplates[this.selectedActionUuid]
    }
  },

  watch: {
    selectedActionUuid() {
      if (!this.selectedActionTemplate) { return }
      this.action = {
        name: this.selectedActionTemplate.name,
        template_id: this.selectedActionTemplate.uuid,
        input_mapping: {},
        static_params: {},
        uuid: UUID(),
        defaults: null,
        traits: [],
        runtime_traits: false
      }
    }
  },

  mounted() {
    // preserve initial height when filtering
    this.customStyle = {
      minHeight: `${this.$el.clientHeight}px`
    }
  }

}
</script>

<template>
  <div :style="customStyle">
    <div class="columns">
      <div class="column is-narrow" style="max-width:250px">
        <b-field>
          <b-input v-model="searchQuery" icon="magnify" type="text" placeholder="Filter"></b-input>
        </b-field>
        <b-field>
          <div v-if="actionTemplateCollection.length == 0">
            Nothing found
          </div>
          <action-selection-input v-else v-model="selectedActionUuid" :collection="actionTemplateCollection"></action-selection-input>
        </b-field>
      </div>
      <div class="column" v-if="!action">
        <p class="has-text-grey is-inline-block title-padding">
          You can browse available templates here. You can add a custom name and map the inputs before adding the action.
        </p>
      </div>

      <action-form v-else-if="selectedActionTemplate" :template="selectedActionTemplate" :action.sync="action" :workflow="workflow"></action-form>

    </div>
  </div>
</template>

<style lang="scss" scoped>
.defaults {
  margin-top: 15px;
  border-left: 1px solid whitesmoke;
  padding-left: 10px;
  padding-bottom: 15px;
  .column {
    padding: 0.25rem 0.75rem;
  }
}
.title-padding {
  padding: 6px 8px;
}
.spacing {
  padding-top: 5px;
}
</style>